const visit = {
  'visitInstance': {
    'startDate': (new Date()).toISOString().split('T')[0] // "YYYY-mm-dd"
  }
}

export default visit
